<!-- <template>
    <div>
        <TreeNode :node="organizationTree" />
        <p>jdfjcmnfjfcj</p>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from 'vue';

interface TreeNode {
    name: string;
    children?: TreeNode[];
}

export default defineComponent({
    props: {
        node: {
            type: Object as PropType<TreeNode>,
            required: true
        }
    },
    setup(props) {
        const organizationTree: TreeNode = {
            name: 'Organization',
            children: [
                {
                    name: 'Branch 1',
                    children: [
                        {
                            name: 'Main Store 1',
                            children: [
                                { name: 'Sub Store 1' },
                                { name: 'Sub Store 2' }
                            ]
                        },
                        {
                            name: 'Main Store 2',
                            children: [
                                { name: 'Sub Store 3' }
                            ]
                        }
                    ]
                },
                {
                    name: 'Branch 2',
                    children: [
                        {
                            name: 'Main Store 3',
                            children: [
                                { name: 'Sub Store 4' }
                            ]
                        }
                    ]
                }
            ]
        };

        const organizationTreeRef = ref<TreeNode>(organizationTree);

        return {
            organizationTree: organizationTreeRef,
            node: props.node
        };
    }
});
</script>

 Define your TreeNode component
<script lang="ts">
import { defineComponent, PropType } from 'vue';

interface TreeNode {
  name: string;
  children?: TreeNode[];
}

export default defineComponent({
  props: {
    node: {
      type: Object as PropType<TreeNode>,
      required: true
    }
  },
  setup(props) {
    return {
      node: props.node
    };
  }
});
</script> -->

<template>
    <section class="treemap">
        <b-container fluid="xl">
            <b-row>
                <b-col>
                    <div class="field d-flex gap-2 align-items-center">
                        <InputSwitch v-model="openrequests" />
                        <label class="mb-0">Show Open Requests</label>
                    </div>
                </b-col>
                <b-col>
                    <div>
                        <i class="pi pi-plus pe-2"></i>
                        <span>Create a new Store</span>
                    </div>
                    <div>

                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="organization">
                        <img src="../../../../assets/logo/MedwayFaviconLogo.png">
                        <div>
                            <h4>Mocero Health Solutions</h4>
                            <p>Tharamani</p>
                        </div>
                    </div>
                    <div class="m-5"></div>
                    <div class="stores">
                        <div class="storesdiv">
                            <div class="storesicon">
                                MS
                            </div>
                            <div>
                                <p class="light-txt">MS000223</p>
                                <h4>Main Store</h4>
                            </div>
                        </div>
                        <div class="storesvalue">
                            <div>
                                <p>5.5L</p>
                                <p class="light-txt">Inventory Value</p>
                            </div>
                            <div>
                                <p>5.5L</p>
                                <p class="light-txt">Open PO</p>
                            </div>
                            <div>
                                <p>5.5L</p>
                                <p class="light-txt">GRN</p>
                            </div>
                        </div>
                        <div class="pendingrequests">
                            Pending Requests 17
                        </div>
                    </div>
                    <div class="m-5"></div>

                    <div class="stores">
                        <div class="storesdiv">
                            <div class="storesicon">
                                DS
                            </div>
                            <div>
                                <p class="light-txt">DS000223</p>
                                <h4>Department Store</h4>
                            </div>
                        </div>
                        <div class="storesvalue">
                            <div>
                                <p>5.5L</p>
                                <p class="light-txt">Inventory Value</p>
                            </div>
                            <div>
                                <p>5.5L</p>
                                <p class="light-txt">Open PO</p>
                            </div>
                        </div>
                    </div>
                    <div class="m-5"></div>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
export default defineComponent({

    setup() {
        const openrequests = ref(true);

        return {
            openrequests
        };
    }
});
</script>
<style type="scss">
.treemap {
    background: #444444;

    .organization {
        background: #FFFFFF;
        width: max-content;
        border-radius: 5px;
        padding: 10px;
        display: flex;
        gap: 10px;
        align-items: center;

        p {
            color: #999999;
        }
    }

    img {
        width: 40px;
    }

    .stores {
        background: #FFFFFF;
        width: max-content;
        border-radius: 5px;

        .storesdiv {
            background: #FFFFFF;
            display: flex;
            gap: 10px;
            align-items: center;
            padding: 10px;
        }

        .storesicon {
            background-color: #CCD0FF;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .storesvalue {
            display: flex;
            gap: 10px;
            align-items: center;
            background: #e1e1e1;
            padding: 10px;
        }

        .pendingrequests {
            background: #CA5561;
            text-align: center;
            color: #FFFFFF;
            padding: 10px;
        }
    }
}
</style>